import React from 'react';
import { PhxBadge } from '_lex/_atoms/PhxBadge';
import { TemplateStatus } from '../../_types';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import PauseIcon from '@mui/icons-material/Pause';

interface TemplateStatusChipProps {
  status: TemplateStatus;
}

const StatusIcon: React.FC<{ status: TemplateStatus }> = ({ status }) => {
  switch (status) {
    case 'Active':
      return <CheckIcon fontSize='small' />;
    case 'Draft':
      return <EditIcon fontSize='small' />;
    case 'Inactive':
      return <PauseIcon fontSize='small' />;
    default:
      return <EditIcon fontSize='small' />;
  }
};

const TemplateStatusChip: React.FC<TemplateStatusChipProps> = ({ status }) => {
  const getStatusColor = (status: TemplateStatus) => {
    switch (status) {
      case 'Active':
        return 'success';
      case 'Draft':
        return 'neutral';
      case 'Inactive':
        return 'warning';
      default:
        return 'neutral';
    }
  };

  return (
    <PhxBadge
      color={getStatusColor(status)}
      startIcon={<StatusIcon status={status} />}
      size='md'
    >
      {status || 'Unknown'}
    </PhxBadge>
  );
};

export default TemplateStatusChip;
